type FormField = {
  field?: string;
  defaultValue?: unknown;
  [key: string]: unknown;
};

const readImmixAlertPostObject = (): {
  immix_server?: string;
  immix_port?: string;
} => {
  if (typeof localStorage === "undefined" || !localStorage.immixAlertPostObject) {
    return {};
  }

  try {
    return JSON.parse(localStorage.immixAlertPostObject);
  } catch {
    return {};
  }
};

const setFieldDefaultValue = (
  fields: FormField[],
  fieldName: string,
  value: unknown
) => {
  if (value === undefined || value === null || value === "") {
    return;
  }

  const field = fields.find((entry) => entry.field === fieldName);
  if (field) {
    field.defaultValue = value;
  }
};

export const checkFormsForImmixValues = (form: any): any => {
  if (!Array.isArray(form) || form.length === 0) {
    return form ?? [];
  }

  const immixAlertPostObject = readImmixAlertPostObject();
  const updatedForm = form.map((page: FormField[]) =>
    page.map((field: FormField) => ({ ...field }))
  );
  const lastPage = updatedForm[updatedForm.length - 1];

  if (!Array.isArray(lastPage) || lastPage.length === 0) {
    return updatedForm;
  }

  setFieldDefaultValue(
    lastPage,
    "immix_server",
    immixAlertPostObject.immix_server
  );
  setFieldDefaultValue(lastPage, "immix_port", immixAlertPostObject.immix_port);

  return updatedForm;
};
